import { makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import DateAdapter from '@mui/lab/AdapterMoment';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { useDispatch, useSelector } from 'react-redux';
import dateIcon from './Date.svg';
import { setClaimDraft } from '../../actions/claimAction';
import { CStandardInput } from '../../component/Input';
import { AutocompleteSelect, DefaultSelect, MultipleSelect } from '../../component/Select';
import COUNTRIES from '../../constant/countries';

const useStyles = makeStyles({
  date: {
    transform: 'translate(-28px, -10px) scale(0.83)'
  },
  featuredOnText: {
    display: 'flex',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    justifyContent: 'center',
    transform: 'translateY(5px)'
  },
  featuredOnValue: {
    display: 'flex',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    justifyContent: 'center',
    marginLeft: '10px',
    transform: 'translateY(8px)'
  },
  gridContainer: {
    alignItems: 'space-between',
    display: 'grid',
    gridRowGap: '35px',
    gridTemplateColumns: '315px 315px',
    height: '100%',
    justifyContent: 'space-between',
    width: '100%'
  },
  gridItem: {
    width: 'fit-content'
  },
  mainDiv: {
    background: '#F0F4FF',
    borderRadius: '10px',
    margin: '30px 40px 0px 35px',
    padding: '40px 135px'
  },
  phoneWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '320px'
  },
  root: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '315px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      top: '-7px',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  rootPhone: {
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '220px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '13px',
      top: '-7px',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-27px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  selectHeader: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px',
    textAlign: 'start',
    transform: 'translate(-30px, -15px) scale(0.83)'
  },
  selectHeaderPhone: {
    transform: 'translate(-10px, -10px) scale(0.83)'
  }
});

const dateStyle = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '12px',
  color: 'black',
  fontFamily: 'Poppins',
  fontSize: '12px',
  margin: '0px',
  padding: '5.225px 11px',
  width: '315px'
};

const autocompleteSelectLabel = {
  color: '#9BA0AD',
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '100%',
  margin: '0px',
  textAlign: 'start',
  transform: 'translate(-30px, -5px) scale(0.83)'
};

const PersonalInfo = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const genders = [
    { key: 'male', value: 'Male' },
    { key: 'female', value: 'Female' }
  ];

  const heardFrom = ['friend', 'tourism agency', 'facebook', 'instagram', 'linkedin', 'airport'];

  const ticketsBoughtAt = ['airline', 'tourism agency', 'web site', 'application', 'concierge'];

  const communicateVias = ['email', 'phone', 'viber', 'watsapp', 'telegram'];

  const claimDraft = useSelector(({ claims }) => claims.claimDraft);

  const handleChange = (newValue) => {
    dispatch(setClaimDraft({ ...claimDraft, birthDate: new Date(newValue) }));
  };

  const onChangeHandler = (type, data) => {
    dispatch(
      setClaimDraft({
        ...claimDraft,
        [type]: data
      })
    );
  };

  const phoneCodes = ['+995', '+1'];

  return (
    <div className={classes.mainDiv}>
      <div className={classes.gridContainer}>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-name"
            id="standard-input-claim-detail-name"
            label="First Name"
            onChange={(e) => onChangeHandler('firstName', e.target.value)}
            size="large"
            value={claimDraft.firstName || ''}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-name"
            id="standard-input-claim-detail-name"
            label="Last Name"
            onChange={(e) => onChangeHandler('lastName', e.target.value)}
            size="large"
            value={claimDraft.lastName || ''}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-id-number"
            id="standard-input-claim-detail-id-number"
            label="ID Number"
            onChange={(e) => onChangeHandler('idNumber', e.target.value)}
            size="large"
            value={claimDraft.idNumber || ''}
          />
        </div>

        <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
          <div className={`${classes.selectHeader} ${classes.date}`}>Birthday</div>
          <LocalizationProvider dateAdapter={DateAdapter}>
            <DesktopDatePicker
              components={{
                OpenPickerIcon: () => (
                  <img alt="dropdown" src={dateIcon} style={{ marginRight: '8px' }} />
                )
              }}
              inputFormat="DD/MM/yyyy"
              InputProps={{
                disableUnderline: true,
                style: dateStyle
              }}
              onChange={handleChange}
              renderInput={(params) => <TextField {...params} />}
              value={claimDraft.birthDate || ''}
            />
          </LocalizationProvider>
        </div>

        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root } || ''}
            htmlFor="standard-input-claim-detail-passport"
            id="standard-input-claim-detail-passport"
            label="Passport Number"
            onChange={(e) => onChangeHandler('passportNumber', e.target.value)}
            size="large"
            value={claimDraft.passportNumber || ''}
          />
        </div>

        <div className={classes.gridItem}>
          <p className={classes.selectHeader}>Gender</p>
          <DefaultSelect
            onSelect={(gender) => {
              onChangeHandler('gender', gender);
            }}
            selectStyles={{
              textAlign: 'start',
              transform: 'translateY(-10px)',
              width: '315px'
            }}
            value={claimDraft.gender || ''}
          >
            {genders.map((gender) => {
              return (
                <MenuItem key={gender.key} value={gender.key}>
                  {gender.value}
                </MenuItem>
              );
            })}
          </DefaultSelect>
        </div>

        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-city"
            id="standard-input-claim-detail-city"
            label="City"
            onChange={(e) => onChangeHandler('city', e.target.value)}
            size="large"
            value={claimDraft.city || ''}
          />
        </div>

        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-email"
            id="standard-input-claim-detail-email"
            label="Email"
            onChange={(e) => onChangeHandler('email', e.target.value)}
            size="large"
            value={claimDraft.email || ''}
          />
        </div>

        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-address"
            id="standard-input-claim-detail-address"
            label="Address"
            onChange={(e) => onChangeHandler('address', e.target.value)}
            size="large"
            value={claimDraft.address || ''}
          />
        </div>

        <div className={classes.gridItem}>
          <div className={classes.phoneWrapper}>
            <div style={{ width: 'fit-content' }}>
              <p className={`${classes.selectHeader} ${classes.selectHeaderPhone} `}>Phone</p>
              <DefaultSelect
                onSelect={(phoneCode) => onChangeHandler('phoneCode', phoneCode)}
                selectStyles={{
                  textAlign: 'start',
                  transform: 'translateY(-6px)',
                  width: '85px'
                }}
                value={claimDraft.phoneCode || ''}
              >
                {phoneCodes.map((phoneCode) => {
                  return (
                    <MenuItem key={phoneCode} value={phoneCode}>
                      {phoneCode}
                    </MenuItem>
                  );
                })}
              </DefaultSelect>
            </div>
            <CStandardInput
              disableUnderline
              formclasses={{ root: classes.rootPhone }}
              htmlFor="standard-input-claim-detail-address"
              id="standard-input-claim-detail-address"
              onChange={(e) => onChangeHandler('phoneNumber', e.target.value)}
              size="large"
              value={claimDraft.phoneNumber || ''}
            />
          </div>
        </div>

        <div className={classes.gridItem}>
          <p style={autocompleteSelectLabel}>Country of residency</p>
          <AutocompleteSelect
            getOptionLabel={(option) => option}
            id="autocomplete-countryOfResidence"
            onSelect={(country) => onChangeHandler('countryOfResidence', country)}
            options={COUNTRIES.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase()))}
            placeholderValue={claimDraft?.countryOfResidence || ''}
            styles={{
              background: 'white',
              width: '315px'
            }}
          />
        </div>
        <div className={classes.gridItem}>
          <p style={autocompleteSelectLabel}>Tickets Bought At</p>
          <AutocompleteSelect
            getOptionLabel={(option) => option}
            id="autocomplete-purchasedTicketVia"
            onSelect={(ticketsBoughtAt) => onChangeHandler('purchasedTicketVia', ticketsBoughtAt)}
            options={ticketsBoughtAt.sort((a, b) =>
              a?.toLowerCase().localeCompare(b?.toLowerCase())
            )}
            placeholderValue={claimDraft?.purchasedTicketVia || ''}
            styles={{
              background: 'white',
              width: '315px'
            }}
          />
        </div>
        <div className={classes.gridItem}>
          <p style={autocompleteSelectLabel}>Heard About Us</p>
          <AutocompleteSelect
            getOptionLabel={(option) => option}
            id="autocomplete-foundUsVia"
            onSelect={(foundUsVia) => onChangeHandler('foundUsVia', foundUsVia)}
            options={heardFrom.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase()))}
            placeholderValue={claimDraft?.foundUsVia || ''}
            styles={{
              background: 'white',
              width: '315px'
            }}
          />
        </div>
        <div className={classes.gridItem}>
          <MultipleSelect
            currentValue={claimDraft.communicateVias || []}
            handleChange={(value) => {
              dispatch(
                setClaimDraft({
                  ...claimDraft,
                  communicateVias: typeof value === 'string' ? value.split(',') : value
                })
              );
            }}
            selectOptions={communicateVias}
            styles={{ textAlign: 'start', width: '315px' }}
            type="text"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
